import { getLeagueCommitteeMemberImagesRequest } from "../repositories/league_committee_member_repository";
export const LeagueCommitteeMemberService = () => {
    const fetchLeagueCommitteeMemberImages = async (setLeagueCommitteeMembers) => {
        try {
            
            const response = await getLeagueCommitteeMemberImagesRequest();
            if (response?.success) {
                setLeagueCommitteeMembers(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch league committee member images.");
        }
    };
    return {
        fetchLeagueCommitteeMemberImages,
    };
};